// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$lecturerApiService = {
      lecturer_api_url: `${process.env.VUE_APP_COURSE_API_URL}/lecturers`,
      
      /**
       * 查詢講師
       * @param {*} param 
       * @returns 
       */
      async query(param = '') {
        const url = `${this.lecturer_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 透過 ID 查詢講師
       * @param {*} id 
       * @param {*} additional 
       * @returns 
       */
      async getById(id, additional = '') {
        const url = `${this.lecturer_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      },

      /**
       * 取得講師照片
       * @param {*} lecturer 
       * @param {*} additional 
       * @returns 
       */
      async getPhoto(lecturer, additional = '') {
        const url = `${this.lecturer_api_url}/${lecturer.id}/photo`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        
        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
